export const TAGS_SEPARATOR = '/';
export const TAGS_VALUE_SEPARATOR = ':';
export const CATEGORY_INDEX = 0;
export const VALUE_INDEX = 1;
export const TAGS_CATEGORY_CSV_SEPARATOR = '.';
export const TREE_NODE_HEADER_SUFFIX = 'HEADER';
export const TREE_MASTER_ROOT_ID = 'TREE_MASTER_ROOT_ID';
/** zone:1/region:2, match is 2 */
export const MATCH_EVERYTHING_AFTER_LAST_COLON_REGEX = /([^:]+$)/;
export const REGEX_INCLUDES_LOCATION_TAGGING_SPECIAL_CHARACTERS =
  /[`!@#$%^&*()+=[\]{};':"\\|,.<>/?~]/;
export const EXTERNAL_ID_HEADER = 'External ID';
export const LOCATION_ID_HEADER = 'Location ID - Solink Use';
export const LOCATION_HEADER = 'Location';
export const DEFAULT_HEADERS = [EXTERNAL_ID_HEADER, LOCATION_ID_HEADER, LOCATION_HEADER];
export const MAJOR_CSV_ERROR = 'major';
export const MINOR_CSV_ERROR = 'minor';
